import { render } from "./UnitTypesAssignment.vue?vue&type=template&id=0781f762&scoped=true"
import script from "./UnitTypesAssignment.vue?vue&type=script&lang=js"
export * from "./UnitTypesAssignment.vue?vue&type=script&lang=js"

import "./UnitTypesAssignment.vue?vue&type=style&index=0&id=0781f762&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0781f762"]])

export default __exports__